<div class="app-modal-title">Select a layer</div>
<div class="app-modal-content">
	<div class="layer-list">
		<!-- <div class="layer-item" *ngFor="let layer of layers; let idx = index;">
			<input name="select-{{idx}}" type="radio" [value]="layer" [(ngModel)]="selectedLayer">
			<label>{{layer.label}}</label>
		</div> -->
		<div class="layer-item" *ngFor="let layer of layers; let idx = index;">
			<input name="select-{{idx}}" type="checkbox" [(ngModel)]="layer.selected">
			<label>{{layer.label}}</label>
		</div>
	</div>
</div>
<div class="app-modal-footer">
	<div class="button-group">
		<button class="button-general" (click)="cancel()">Cancel</button>
		<button class="button-general" [disabled]="disableQc()" (click)="runQc()">Run QC</button>
	</div>
</div>